
import { Application as CoreApplication } from 'apprise-frontend-core/application'
import { UserInterface, UserInterfaceProps } from 'apprise-ui/provider'
import { ComponentProps } from 'react'


// wrap a headless application to add a user interface, for convenience.

export const Application = (props: ComponentProps<typeof CoreApplication> & Partial<{

    ui: UserInterfaceProps

}>) => {

    const { children, ui, ...rest } = props

    return <CoreApplication {...rest}>
        <UserInterface {...ui}>
            {children}
        </UserInterface>
    </CoreApplication>

}